import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Navigation from '../components/Navigation';
import { PersonalService } from '../services/personalService';
import '../styles/pages/personal.css';

const AREA_AVATAR = {
    'Recepción':    'a-recep',
    'Veterinaria':  'a-vet',
    'Estética':     'a-groom',
    'Guardería':    'a-care',
    'Administración': 'a-admin',
    'Transporte':   'a-bus',
};

const ESTATUS_PILL = {
    activo:      { cls: 'solid-ok',  txt: '● Activo' },
    vacaciones:  { cls: 'solid-vac', txt: '● En vacaciones' },
    incapacidad: { cls: 'solid-inc', txt: '● Incapacidad' },
    incidencia:  { cls: 'solid-inc', txt: '● Incidencia' },
    baja:        { cls: '',          txt: '● Baja' },
};

const FLAG_MAP = {
    ok:   { cls: 'ok',   txt: 'Entregado' },
    warn: { cls: 'warn', txt: 'Pendiente' },
    bad:  { cls: 'bad',  txt: 'Falta' },
};

const LOG_TAG = {
    ok:     { txt: 'Completo',    bg: 'var(--pe-ok-bg)',   c: 'var(--pe-ok-ink)' },
    late:   { txt: 'Retardo',     bg: 'var(--pe-warn-bg)', c: 'var(--pe-warn-ink)' },
    absent: { txt: 'Falta',       bg: 'var(--pe-bad-bg)',  c: 'var(--pe-bad-ink)' },
    inc:    { txt: 'Incapacidad', bg: 'var(--pe-blue-bg)', c: 'var(--pe-blue-ink)' },
};

const INC_CLASS = {
    'activo':      'pe-st-act',
    'vacaciones':  'pe-st-vac',
    'incidencia':  'pe-st-inc',
    'incapacidad': 'pe-st-inc',
    'baja':        'pe-st-baja',
};

function calcAntiguedad(fechaIngreso) {
    if (!fechaIngreso) return '';
    const from = new Date(fechaIngreso);
    const now = new Date();
    let years = now.getFullYear() - from.getFullYear();
    let months = now.getMonth() - from.getMonth();
    if (months < 0) { years -= 1; months += 12; }
    if (years === 0 && months === 0) return 'Reciente';
    const yStr = years > 0 ? `${years} año${years !== 1 ? 's' : ''}` : '';
    const mStr = months > 0 ? `${months} mes${months !== 1 ? 'es' : ''}` : '';
    return [yStr, mStr].filter(Boolean).join(' ');
}

function getInitials(nombre) {
    if (!nombre) return '?';
    const parts = nombre.trim().split(/\s+/);
    return (parts[0][0] + (parts[1]?.[0] || '')).toUpperCase();
}

// ── Tab: Datos ─────────────────────────────────────────────────
function TabDatos({ e, id, navigate }) {
    const flagEl = (doc) => {
        if (!doc) return null;
        const f = FLAG_MAP[doc.estado] || FLAG_MAP.warn;
        return <span className={`pe-docflag ${f.cls}`}>{f.txt}</span>;
    };

    return (
        <div>
            <div className="pe-sec-label">Datos personales</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div className="pe-kv"><span className="k">CURP</span><span className="v mono">{e.curp || '—'}</span></div>
                <div className="pe-kv"><span className="k">RFC</span><span className="v mono">{e.rfc || '—'}</span></div>
                <div className="pe-kv"><span className="k">NSS</span><span className="v mono">{e.nss || '—'}</span></div>
                <div className="pe-kv"><span className="k">Nacimiento</span><span className="v">{e.nacimiento || '—'}</span></div>
                <div className="pe-kv"><span className="k">Domicilio</span><span className="v" style={{ maxWidth: '62%' }}>{e.domicilio || '—'}</span></div>
            </div></div>

            <div className="pe-sec-label">Contacto</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div className="pe-kv"><span className="k">Teléfono</span><span className="v mono">{e.tel || '—'}</span></div>
                <div className="pe-kv"><span className="k">Correo</span><span className="v">{e.email || '—'}</span></div>
            </div></div>

            <div className="pe-sec-label">Documentación legal</div>
            <div className="pe-card">
                <div className="pe-doc">
                    <div className="di">🪪</div>
                    <div className="pe-doc-info">
                        <div className="pe-doc-name">Identificación oficial (INE)</div>
                        <div className="pe-doc-sub">{e.ine?.detalle || 'Pendiente'}</div>
                    </div>
                    {flagEl(e.ine)}
                </div>
                <div className="pe-doc">
                    <div className="di">🏠</div>
                    <div className="pe-doc-info">
                        <div className="pe-doc-name">Comprobante de domicilio</div>
                        <div className="pe-doc-sub">{e.compDomicilio?.detalle || 'Pendiente'}</div>
                    </div>
                    {flagEl(e.compDomicilio)}
                </div>
                <div className="pe-doc">
                    <div className="di">📄</div>
                    <div className="pe-doc-info">
                        <div className="pe-doc-name">Contrato de trabajo</div>
                        <div className="pe-doc-sub">{e.contrato?.detalle || 'Pendiente'}</div>
                    </div>
                    {flagEl(e.contrato)}
                </div>
                <div className="pe-doc">
                    <div className="di">🏦</div>
                    <div className="pe-doc-info">
                        <div className="pe-doc-name">Retenciones de crédito</div>
                        <div className="pe-doc-sub">{e.retenciones?.detalle || 'Sin información'}</div>
                    </div>
                    {flagEl(e.retenciones)}
                </div>
            </div>
            <button className="pe-add-btn" onClick={() => navigate(`/settings/personal/${id}/edit`)}>
                ✏️ Actualizar estado de documentos
            </button>
        </div>
    );
}

// ── Tab: Médico ────────────────────────────────────────────────
function TabMedico({ e }) {
    const emergencia = e.emergencia || [];
    return (
        <div>
            <div className="pe-sec-label">Contactos de emergencia</div>
            <div className="pe-card">
                {emergencia.map((c, i) => (
                    <div className="pe-ec" key={i}>
                        <div className="pe-ec-av">{getInitials(c.nombre)}</div>
                        <div className="pe-ec-info">
                            <div className="pe-ec-name">{c.nombre}</div>
                            <div className="pe-ec-rel">{c.rel} · {c.tel}</div>
                        </div>
                        <a href={`tel:${c.tel}`} className="pe-ec-call" title="Llamar">📞</a>
                    </div>
                ))}
                {emergencia.length < 2 && (
                    <div className="pe-ec" style={{ opacity: .7 }}>
                        <div className="pe-ec-av" style={{ background: '#f3f4f6', color: '#9ca3af' }}>+</div>
                        <div className="pe-ec-info">
                            <div className="pe-ec-name" style={{ color: '#9ca3af' }}>Agregar {emergencia.length === 0 ? '1er' : '2º'} contacto</div>
                            <div className="pe-ec-rel">Se recomienda al menos dos</div>
                        </div>
                    </div>
                )}
            </div>

            <div className="pe-sec-label">Datos de salud</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div className="pe-kv"><span className="k">Tipo de sangre</span><span className="v">{e.sangre || '—'}</span></div>
                <div className="pe-kv"><span className="k">Alergias graves</span><span className="v">{e.alergias || '—'}</span></div>
                <div className="pe-kv"><span className="k">Enf. crónicas</span><span className="v">{e.cronicas || '—'}</span></div>
                <div className="pe-kv"><span className="k">Medicamentos</span><span className="v">{e.medicamentos || '—'}</span></div>
            </div></div>

            <div className="pe-sec-label">Atención médica</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div className="pe-kv"><span className="k">Clínica IMSS</span><span className="v">{e.clinica || '—'}</span></div>
                <div className="pe-kv"><span className="k">SGMM particular</span><span className="v" style={{ maxWidth: '60%' }}>{e.seguro || '—'}</span></div>
            </div></div>
        </div>
    );
}

// ── Mini calendar ──────────────────────────────────────────────
function MiniCal({ taken = [], req = [] }) {
    const dows = ['D', 'L', 'M', 'M', 'J', 'V', 'S'];
    const now = new Date();
    const year = now.getFullYear();
    const month = now.getMonth();
    const firstDay = new Date(year, month, 1).getDay();
    const daysInMonth = new Date(year, month + 1, 0).getDate();

    const cells = [];
    for (let i = 0; i < firstDay; i++) cells.push(<div key={'b' + i} className="cell muted" />);
    for (let d = 1; d <= daysInMonth; d++) {
        let cls = 'cell';
        if (taken.includes(d)) cls += ' vac';
        else if (req.includes(d)) cls += ' req';
        cells.push(<div key={d} className={cls}>{d}</div>);
    }

    return (
        <div>
            <div className="pe-cal">{dows.map((d, i) => <div key={'h' + i} className="dow">{d}</div>)}</div>
            <div className="pe-cal">{cells}</div>
        </div>
    );
}

// ── Tab: Control operativo ─────────────────────────────────────
function TabControl({ e }) {
    const asist = e.asistencia || { asistencias: 0, retardos: 0, faltas: 0 };
    const vac = e.vacaciones || { derecho: 0, tomados: 0 };
    const pendientes = vac.derecho - vac.tomados;
    const pct = n => vac.derecho > 0 ? (n / vac.derecho) * 100 : 0;
    const log = e.log || [];
    const incidencias = e.incidencias || [];

    const monthName = new Date().toLocaleDateString('es-MX', { month: 'long', year: 'numeric' });

    return (
        <div>
            <div className="pe-sec-label">Asistencia · {monthName}</div>
            <div className="pe-stat-grid">
                <div className="pe-stat ok"><div className="n">{asist.asistencias}</div><div className="l">Asistencias</div></div>
                <div className="pe-stat warn"><div className="n">{asist.retardos}</div><div className="l">Retardos</div></div>
                <div className="pe-stat bad"><div className="n">{asist.faltas}</div><div className="l">Faltas</div></div>
            </div>

            {log.length > 0 && (
                <>
                    <div className="pe-sec-label" style={{ marginTop: 16 }}>Registro reciente</div>
                    <div className="pe-card">
                        {log.slice(0, 5).map((l, i) => {
                            const fecha = l.fecha ? new Date(l.fecha) : null;
                            const d = fecha ? fecha.getDate().toString().padStart(2, '0') : '—';
                            const m = fecha ? fecha.toLocaleDateString('es-MX', { month: 'short' }) : '';
                            const t = LOG_TAG[l.tag] || LOG_TAG.ok;
                            return (
                                <div className="pe-log" key={i}>
                                    <div className="pe-log-date">
                                        <div className="d">{d}</div>
                                        <div className="m">{m}</div>
                                    </div>
                                    <div className="pe-log-times">
                                        {l.entrada === '—' || !l.entrada
                                            ? <span>Sin registro</span>
                                            : <>Entrada {l.entrada} · <span>Salida {l.salida || '—'}</span></>}
                                    </div>
                                    <span className="pe-log-tag" style={{ background: t.bg, color: t.c }}>{t.txt}</span>
                                </div>
                            );
                        })}
                    </div>
                </>
            )}

            <div className="pe-sec-label" style={{ marginTop: 16 }}>Vacaciones</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'baseline' }}>
                    <span style={{ fontWeight: 800, fontSize: '.92rem' }}>Saldo del periodo</span>
                    <span style={{ fontWeight: 900, color: 'var(--pe-pri-d)' }}>{pendientes} días disponibles</span>
                </div>
                <div className="pe-vac-bar">
                    <i className="taken" style={{ width: pct(vac.tomados) + '%' }} />
                    <i className="left"  style={{ width: pct(pendientes) + '%' }} />
                </div>
                <div className="pe-vac-legend">
                    <span><span className="dot" style={{ background: 'var(--pe-pri)' }} />Tomados <b>{vac.tomados}</b></span>
                    <span><span className="dot" style={{ background: '#c4b5fd' }} />Pendientes <b>{pendientes}</b></span>
                    <span><span className="dot" style={{ background: 'var(--pe-line)' }} />Derecho <b>{vac.derecho}</b></span>
                </div>
                <div className="pe-divider" />
                <MiniCal taken={[]} req={[]} />
            </div></div>
            <button className="pe-add-btn">＋ Registrar solicitud de vacaciones</button>

            <div className="pe-sec-label" style={{ marginTop: 16 }}>Incidencias</div>
            <div className="pe-inc-list">
                {incidencias.length === 0 && (
                    <div className="pe-card"><div className="pe-card-bd">
                        <span style={{ color: 'var(--pe-muted)', fontWeight: 700, fontSize: '.85rem' }}>Sin incidencias en el periodo.</span>
                    </div></div>
                )}
                {incidencias.map((inc, i) => (
                    <div className="pe-inc-card" key={i}><div className="pe-inc-bd">
                        <div className="pe-inc-main">
                            <div className="pe-inc-meta">
                                <span className="pe-st pe-st-inc">{inc.tipo}</span>
                                <span style={{ fontSize: '.74rem', fontWeight: 700, color: 'var(--pe-muted)' }}>{inc.fecha}</span>
                            </div>
                            <div className="pe-inc-detail">{inc.detalle}</div>
                        </div>
                        {inc.doc && <span className="pe-docflag ok" title="Justificante adjunto">📎 Doc</span>}
                    </div></div>
                ))}
            </div>
            <button className="pe-add-btn" style={{ marginTop: 10 }}>＋ Registrar incidencia</button>
        </div>
    );
}

// ── Tab: Nómina ────────────────────────────────────────────────
function TabNomina({ e }) {
    const pagos = e.pagos || [];
    return (
        <div>
            <div className="pe-sec-label">Datos bancarios</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div className="pe-kv"><span className="k">Banco</span><span className="v">{e.banco || '—'}</span></div>
                <div className="pe-kv"><span className="k">Cuenta</span><span className="v mono">{e.cuenta || '—'}</span></div>
                <div className="pe-kv"><span className="k">CLABE</span><span className="v mono">{e.clabe || '—'}</span></div>
            </div></div>

            <div className="pe-sec-label">Sueldo</div>
            <div className="pe-card"><div className="pe-card-bd">
                <div className="pe-kv"><span className="k">Sueldo base</span><span className="v">{e.sueldoBase || '—'}</span></div>
                <div className="pe-kv"><span className="k">Esquema</span><span className="v">Quincenal · transferencia</span></div>
            </div></div>

            <div className="pe-sec-label">Historial de pagos · recibos CFDI</div>
            {pagos.length === 0 ? (
                <div className="pe-card"><div className="pe-card-bd">
                    <span style={{ color: 'var(--pe-muted)', fontWeight: 700, fontSize: '.85rem' }}>Sin pagos registrados.</span>
                </div></div>
            ) : (
                <div className="pe-card">
                    {pagos.map((p, i) => (
                        <div className="pe-pay" key={i}>
                            <div className="cfg-icon cfg-icon--green" style={{ borderRadius: 10, flexShrink: 0 }}>🧾</div>
                            <div className="pe-pay-info">
                                <div className="pe-pay-per">{p.per}</div>
                                <div className="pe-pay-sub">{p.sub}</div>
                            </div>
                            <div className="pe-pay-amt">
                                <div className="pe-pay-net">{p.net}</div>
                                {p.cfdi && <div className="pe-pay-cfdi">✓ CFDI timbrado</div>}
                            </div>
                        </div>
                    ))}
                </div>
            )}
            <button className="pe-add-btn">⬇ Descargar recibos del periodo</button>
        </div>
    );
}

// ── Main component ─────────────────────────────────────────────
const TABS = [
    { id: 'datos',    l: 'Datos' },
    { id: 'medico',   l: 'Médico' },
    { id: 'control',  l: 'Control' },
    { id: 'nomina',   l: 'Nómina' },
];

export default function PersonalExpediente() {
    const { id } = useParams();
    const navigate = useNavigate();
    const { authorizedFetch, role } = useAuth();

    const [emp, setEmp] = useState(null);
    const [tab, setTab] = useState('datos');
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');

    useEffect(() => {
        if (role !== 'admin') { navigate('/settings'); return; }
        PersonalService.getById(id, authorizedFetch)
            .then(setEmp)
            .catch(() => setError('No se pudo cargar el expediente.'))
            .finally(() => setLoading(false));
    }, [id]); // eslint-disable-line

    if (loading) return (
        <>
            <Navigation />
            <div className="pe-loading" style={{ paddingTop: 100 }}>Cargando…</div>
        </>
    );

    if (error || !emp) return (
        <>
            <Navigation />
            <div className="pe-container">
                <button className="pe-back-link" onClick={() => navigate('/settings/personal')}>‹ Directorio</button>
                <div className="pe-toast error">{error || 'Empleado no encontrado.'}</div>
            </div>
        </>
    );

    const heroPill = ESTATUS_PILL[emp.estatus] || ESTATUS_PILL.activo;
    const avatarCls = AREA_AVATAR[emp.area] || '';
    const antiguedad = calcAntiguedad(emp.ingreso);
    const ingresoFmt = emp.ingreso
        ? new Date(emp.ingreso).toLocaleDateString('es-MX', { day: '2-digit', month: 'short', year: 'numeric' })
        : '—';

    return (
        <>
            <Navigation />

            {/* Hero */}
            <div className="pe-hero">
                <span className="pe-hero-paw">🐾</span>
                <div style={{ maxWidth: 520, margin: '0 auto' }}>
                    <button className="pe-back-link" style={{ color: '#C9BEF2', marginBottom: 12 }} onClick={() => navigate('/settings/personal')}>
                        ‹ Directorio
                    </button>
                    <div className="pe-hero-row">
                        <div className={`pe-hero-avatar`}>{getInitials(emp.nombre)}</div>
                        <div style={{ minWidth: 0 }}>
                            <h2 className="pe-hero-name">{emp.nombre}</h2>
                            <div className="pe-hero-role">{emp.puesto} · {emp.area}</div>
                        </div>
                    </div>
                    <div className="pe-pills">
                        <span className={`pe-pill ${heroPill.cls}`}>{heroPill.txt}</span>
                        {antiguedad && <span className="pe-pill">Antigüedad {antiguedad}</span>}
                        <span className="pe-pill">Ingreso {ingresoFmt}</span>
                    </div>
                </div>
            </div>

            {/* Tabs */}
            <div className="pe-tabs" style={{ maxWidth: 520, margin: '0 auto' }}>
                {TABS.map(t => (
                    <button key={t.id} className={`pe-tab ${tab === t.id ? 'on' : ''}`} onClick={() => setTab(t.id)}>
                        {t.l}
                    </button>
                ))}
            </div>

            {/* Tab body */}
            <div className="pe-tab-body">
                {tab === 'datos'   && <TabDatos   e={emp} id={id} navigate={navigate} />}
                {tab === 'medico'  && <TabMedico  e={emp} />}
                {tab === 'control' && <TabControl e={emp} />}
                {tab === 'nomina'  && <TabNomina  e={emp} />}

                <div className="pe-btn-row" style={{ marginTop: 18 }}>
                    <button className="pe-btn pe-btn-ghost" onClick={() => navigate(`/settings/personal/${id}/edit`)}>
                        Editar
                    </button>
                    <button className="pe-btn pe-btn-danger"
                        onClick={async () => {
                            if (!window.confirm(`¿Dar de baja a ${emp.nombre}?`)) return;
                            await PersonalService.update(id, { ...emp, estatus: 'baja' }, authorizedFetch);
                            navigate('/settings/personal');
                        }}>
                        Dar de baja
                    </button>
                </div>
            </div>
        </>
    );
}
